/*globals require, module, $, BluugoBrowser, TCApi, swal, Confirm */
var Block = require('../libs/block');

module.exports = Block.extend({
    template: '#exa51test',

    init: function () {
        this.hooks.connectButton = document.getElementById('connect');
        this.hooks.inventoryButton = document.getElementById('inventory');
        this.hooks.settingsButton = document.getElementById('settings');
        this.hooks.writeButton = document.getElementById('write');
        this.exa51Plugin = BluugoBrowser.plugin('exa51');
        if (this.exa51Plugin.isAvailable()) {
            if (this.exa51Plugin.info.enabled) {
                this.exa51Plugin.call('start');
            }
            this.exa51Plugin.on('result', this.handleExa51Result.bind(this));
        } else {
            console.log('plugin not available')
        }
        this.hooks.connectButton.onclick = this.connect.bind(this);
        this.hooks.inventoryButton.onclick = this.inventory.bind(this);
        this.hooks.settingsButton.onclick = this.settings.bind(this);
        this.hooks.writeButton.onclick = this.write.bind(this);
    },

    write: function() {
        this.exa51Plugin.call('write', {
            'content': $('#tag_content').val(),
            'readonly': $('#read_only').is(':checked')
        });
    },

    settings: function() {
        this.exa51Plugin.call('settings', {
            'regionId': $('#region_id').val(),
            'txLevel': $('#tx_level').val(),
            'linkFreq': $('#link_freq').val(),
            'rxDecoding': $('#rx_decoding').val(),
            'txModulation': $('#tx_modulation').val(),
            'inventoryQ': $('#inventory_q').val(),
            'inventoryRounds': $('#inventory_rounds').val(),
            'inventorySession': $('#inventory_session').val(),
            'inventoryTarget': $('#inventory_target').val(),
            'antennas': $('#antennas').val(),
            'autoTune': $('#autotune').is(':checked')
         });
    },

    inventory: function() {
        this.exa51Plugin.call('inventory');
    },

    connect: function() {
        this.exa51Plugin.call('connect');
    },

    handleExa51Result: function (jsonResult) {
        console.log(jsonResult.string);
//        var errStr = '';
//        switch (jsonResult.code) {
//            case -200: // No connection
//                break;
//            default:
//            case 0:
//                jsonResult.string
//                break;
//        }
    },
});